import React, { useState, MouseEvent } from 'react';
import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ImageWithZoomProps extends BoxProps {
	src: string;
	alt?: string;
}

const ImageContainer = styled(Box)(() => ({
	overflow: 'hidden',
	position: 'relative',
	cursor: 'zoom-in',
	width: '100%',
	height: '100%',
	userSelect: 'none',
}));

const ZoomImage = styled('img')({
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	transition: 'transform 0.1s ease-out',
	userSelect: 'none',
});

export const ImageWithZoom: React.FC<ImageWithZoomProps> = ({ src, alt, sx, ...props }) => {
	const [transformOrigin, setTransformOrigin] = useState('center center');
	const [scale, setScale] = useState(1);

	const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
		const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
		const x = ((e.clientX - left) / width) * 100;
		const y = ((e.clientY - top) / height) * 100;

		setTransformOrigin(`${x}% ${y}%`);
		setScale(2); // Zoom level
	};

	const handleMouseLeave = () => {
		setScale(1);
		setTransformOrigin('center center');
	};

	return (
		<ImageContainer
			onMouseMove={handleMouseMove}
			onMouseLeave={handleMouseLeave}
			draggable={false}
			sx={sx}
			{...props}
		>
			<ZoomImage
				src={src}
				alt={alt}
				style={{
					transformOrigin,
					transform: `scale(${scale})`,
				}}
				draggable={false}
			/>
		</ImageContainer>
	);
};
